import React from 'react';
import { Button } from '@vtblife/uikit';

import classname from '@search/classname/src';

import './style.css';

const cn = classname.bind(null, 'MortgageButtonsAction');

export const MortgageButtonsAction = ({
    isMobile = false,
    loading = false,
    isEmpty = false,
    // openConsultModal,
    linkAction
}: {
    isMobile?: boolean;
    loading: boolean;
    isEmpty: boolean;
    openConsultModal: () => void;
    linkAction: () => void;
}) => {
    return (
        <>
            <div className={cn(null, { isMobile })}>
                <Button
                    variant='primary'
                    disabled={loading || isEmpty}
                    fullWidth={isMobile}
                    dataTest='MinimalBanksMortgage-send'
                    onClick={() => linkAction()}
                >
                    Перейти к заявке на ипотеку
                </Button>
                {/*<Button*/}
                {/*    variant='secondary'*/}
                {/*    dataTest='MinimalBanksMortgage-show-more'*/}
                {/*    type='submit'*/}
                {/*    fullWidth={isMobile}*/}
                {/*    onClick={openConsultModal}*/}
                {/*>*/}
                {/*    Получить консультацию по ипотеке*/}
                {/*</Button>*/}
            </div>
        </>
    );
};
